module.exports = __webpack_public_path__ + "img/services-shape-1.0224bd7d.svg";